/* Preserve the shopper's current query and sort when narrowing or clearing facets. */
(function () {
  if (window.scarlettDiscoveryBound) return;
  window.scarlettDiscoveryBound = true;
  var selector = '[data-scarlett-clear-filters], a.scarlett-clear-filters, [data-scarlett-stock-filter]';
  function refreshLink(link) {
    var url = new URL(window.location.href);
    url.searchParams.delete('page');
    if (link.hasAttribute('data-scarlett-stock-filter')) {
      url.searchParams.delete('filter.v.availability');
      if (link.getAttribute('data-scarlett-stock-filter') === 'add') url.searchParams.set('filter.v.availability', '1');
    } else {
      Array.from(url.searchParams.keys()).forEach(function (key) {
        if (key.indexOf('filter.') === 0) url.searchParams.delete(key);
      });
    }
    link.href = url.pathname + url.search + url.hash;
  }
  function refreshAll() { document.querySelectorAll(selector).forEach(refreshLink); }
  // Capture runs before Dawn's facet-remove click/Space handler reads the href.
  function prepare(event) {
    var link = event.target.closest && event.target.closest(selector);
    if (link) refreshLink(link);
  }
  document.addEventListener('click', prepare, true);
  document.addEventListener('keyup', prepare, true);
  document.addEventListener('focusin', prepare, true);
  window.addEventListener('popstate', refreshAll);
  refreshAll();
  var grid = document.getElementById('ProductGridContainer');
  if (grid) new MutationObserver(refreshAll).observe(grid, { childList: true });
})();
